<ol class="breadcrumb">
  <li class="breadcrumb-item active">Plans</li>
  <li class="breadcrumb-item">
    <a (click)="openNewActivePlanModal()">
      <app-icon icon="plus" iconClass="button-icon"></app-icon> Add
    </a>
  </li>
</ol>

<span class="heading">Plans</span>

<tabset #tabset>
  <tab (select)="onActiveTabSelection()">
    <ng-template tabHeading>
      Active
    </ng-template>

    <app-active-plan-list></app-active-plan-list>
  </tab>

  <tab (select)="onPendingTabSelection()">
    <ng-template tabHeading>
      Pending
    </ng-template>

    <app-pending-plan-list></app-pending-plan-list>
  </tab>
</tabset>
